import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';

const actions = mapActionsFromConfigurations('session')(configurations);

export default actions;


// WEBPACK FOOTER //
// ./src/state/modules/session/actions.js